import { PropsWithChildren } from 'react';
import { ContactInfoHeader } from 'assets/js/pages/contacts/ContactHeader';

const CompanyHeader = ({ children }: PropsWithChildren) => {
    return (
        <div className={'flex flex-col gap-1'}>
            <div className={'flex items-center gap-4'}>
                <h1 className={'flex items-center gap-2 text-3xl font-medium'}>{children}</h1>
            </div>
            <ContactInfoHeader />
        </div>
    );
};

export { CompanyHeader };
